/* =========================================================
   UNITED STORE — THEME.JS
   Helpers globales: drawer, header scroll-shrink, reveal,
   cart bump, accesibilidad.
   ========================================================= */
(function () {
  'use strict';

  /* ============ HEADER SCROLL SHRINK ============ */
  const header = document.getElementById('site-header');
  if (header) {
    let lastY = 0;
    const onScroll = () => {
      const y = window.scrollY || window.pageYOffset;
      if (y > 40) header.classList.add('header-scrolled');
      else header.classList.remove('header-scrolled');
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ============ MENU DRAWER (lateral mobile) ============ */
  const menuBtn = document.getElementById('menuBtn');
  const closeDrawer = document.getElementById('closeDrawer');
  const drawer = document.getElementById('drawer');
  const drawerBackdrop = document.getElementById('drawerBackdrop');

  const openDrawer = () => {
    if (!drawer) return;
    drawer.style.transform = 'translateX(0)';
    if (drawerBackdrop) drawerBackdrop.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  };
  const hideDrawer = () => {
    if (!drawer) return;
    drawer.style.transform = 'translateX(-100%)';
    if (drawerBackdrop) drawerBackdrop.classList.add('hidden');
    document.body.style.overflow = '';
  };

  if (menuBtn) menuBtn.addEventListener('click', openDrawer);
  if (closeDrawer) closeDrawer.addEventListener('click', hideDrawer);
  if (drawerBackdrop) drawerBackdrop.addEventListener('click', hideDrawer);

  /* Cerrar drawer con Esc */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') hideDrawer();
  });

  /* ============ REVEAL ON SCROLL ============ */
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('visible'));
  }

  /* ============ CART BUMP (animación al agregar al carrito) ============ */
  window.UnitedStore = window.UnitedStore || {};
  window.UnitedStore.cartBump = function () {
    const cartIcon = document.getElementById('cart-icon');
    if (!cartIcon) return;
    cartIcon.classList.remove('cart-bounce');
    void cartIcon.offsetWidth; // reflow
    cartIcon.classList.add('cart-bounce');
  };

  /* ============ UPDATE CART COUNT (helper Shopify Ajax API) ============ */
  window.UnitedStore.refreshCartCount = function () {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.classList.toggle('hidden', cart.item_count === 0);
        });
        window.UnitedStore.cartBump();
      })
      .catch(() => {});
  };


  /* ============ CART DRAWER (mini carrito lateral) ============ */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerBackdrop = document.getElementById('cart-drawer-backdrop');
  const closeCartDrawerBtn = document.getElementById('close-cart-drawer');

  function openCartDrawer() {
    if (!cartDrawer) return;
    /* Refrescar contenido antes de abrir */
    refreshCartDrawerContent().then(() => {
      cartDrawer.style.transform = 'translateX(0)';
      if (cartDrawerBackdrop) cartDrawerBackdrop.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.style.transform = 'translateX(100%)';
    if (cartDrawerBackdrop) cartDrawerBackdrop.classList.add('hidden');
    document.body.style.overflow = '';
  }

  async function refreshCartDrawerContent() {
    const itemsEl = document.getElementById('cart-drawer-items');
    const footerEl = document.getElementById('cart-drawer-footer');
    const shippingEl = document.getElementById('cart-drawer-shipping-bar');
    const countText = document.querySelector('[data-cart-count-text]');
    if (!itemsEl) return;

    try {
      const cart = await fetch('/cart.js').then(r => r.json());

      /* Actualizar contadores */
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.toggle('hidden', cart.item_count === 0);
      });
      if (countText) countText.textContent = '(' + cart.item_count + ')';

      if (cart.item_count === 0) {
        itemsEl.innerHTML = `
          <div class="text-center py-stack-lg">
            <span class="material-symbols-outlined text-6xl text-on-surface-variant mb-stack-md block">shopping_bag</span>
            <p class="font-headline-md text-headline-md uppercase mb-stack-sm">Tu carrito está vacío</p>
            <p class="text-body-md text-on-surface-variant mb-stack-md">Explora nuestras categorías y encuentra tus próximos guayos.</p>
            <a href="/collections/all" class="inline-block bg-primary text-on-primary px-stack-md py-stack-sm font-label-caps text-label-caps uppercase hover:bg-secondary-container transition-colors active:scale-95">Ver productos</a>
          </div>`;
        if (footerEl) footerEl.remove();
        return;
      }

      /* Renderizar items */
      itemsEl.innerHTML = cart.items.map(item => {
        const price = (item.final_price / 100).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 });
        const img = item.image ? `<img src="${item.image}&width=96" alt="${item.title}" class="w-16 h-16 object-cover flex-shrink-0 border border-border-subtle" width="64" height="64" loading="lazy">` : '';
        return `<div class="flex gap-3 py-stack-sm border-b border-border-subtle last:border-0" data-cart-item-key="${item.key}">
          ${img}
          <div class="flex-1 min-w-0">
            <p class="font-label-caps text-label-caps uppercase truncate">${item.product_title}</p>
            <p class="text-on-surface-variant text-xs mt-0.5">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
            <div class="flex items-center justify-between mt-2">
              <div class="flex items-center border border-border-subtle">
                <button type="button" class="px-2 py-1 text-sm hover:bg-surface-container transition-colors cart-qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
                <span class="px-3 text-sm font-medium">${item.quantity}</span>
                <button type="button" class="px-2 py-1 text-sm hover:bg-surface-container transition-colors cart-qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
              </div>
              <span class="font-label-caps text-secondary-container">${price}</span>
            </div>
          </div>
        </div>`;
      }).join('');

      /* Vaciar carrito */
      setTimeout(() => {
        const clearBtn = document.getElementById('cart-clear-btn');
        if (clearBtn) {
          clearBtn.addEventListener('click', async () => {
            if (!confirm('¿Vaciar el carrito?')) return;
            await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
            await refreshCartDrawerContent();
          });
        }
      }, 0);

      /* Attach qty change listeners */
      itemsEl.querySelectorAll('.cart-qty-btn').forEach(btn => {
        btn.addEventListener('click', async () => {
          const key = btn.dataset.key;
          const qty = parseInt(btn.dataset.qty);
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty })
          });
          await refreshCartDrawerContent();
        });
      });

      /* Subtotal */
      const subtotal = (cart.items_subtotal_price / 100).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 });
      const cuota = (cart.total_price / 6 / 100).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 });

      /* Render or update footer */
      let footer = document.getElementById('cart-drawer-footer');
      if (!footer) {
        footer = document.createElement('footer');
        footer.id = 'cart-drawer-footer';
        footer.className = 'border-t border-primary p-stack-md space-y-stack-sm bg-surface-container-lowest';
        cartDrawer.appendChild(footer);
      }
      footer.innerHTML = `
        <div class="flex justify-between items-baseline">
          <span class="font-label-caps text-label-caps uppercase">Subtotal</span>
          <span class="font-display-hero text-headline-md tracking-tighter">${subtotal}</span>
        </div>
        <p class="font-installment-label text-installment-label text-secondary-container">o 6 cuotas de ${cuota} sin interés</p>
        <p class="font-label-caps text-[10px] text-on-surface-variant uppercase">Impuestos incluidos. Envío calculado en checkout.</p>
        <div class="grid grid-cols-2 gap-stack-sm">
          <a href="/cart" class="text-center bg-transparent border border-primary text-primary py-stack-sm font-label-caps text-label-caps tracking-widest hover:bg-primary hover:text-on-primary transition-colors uppercase">Ver carrito</a>
          <a href="/checkout" class="text-center bg-primary text-on-primary py-stack-sm font-label-caps text-label-caps tracking-widest hover:bg-secondary-container transition-colors uppercase flex items-center justify-center gap-1">
            <span class="material-symbols-outlined text-base">lock</span> Checkout
          </a>
        </div>
        <button type="button" id="cart-clear-btn" class="w-full text-center font-label-caps text-[10px] text-on-surface-variant hover:text-red-500 transition-colors uppercase tracking-widest flex items-center justify-center gap-1 mt-1">
          <span class="material-symbols-outlined text-base">delete_sweep</span> Vaciar carrito
        </button>`;

    } catch(e) { console.error('Cart refresh error', e); }
  }

  if (closeCartDrawerBtn) closeCartDrawerBtn.addEventListener('click', closeCartDrawer);
  if (cartDrawerBackdrop) cartDrawerBackdrop.addEventListener('click', closeCartDrawer);

  /* Botones [data-cart-open] abren el drawer */
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openCartDrawer();
    }
  });

  /* Exponer globalmente para product.js */
  window.UnitedStore.openCartDrawer = openCartDrawer;
  window.UnitedStore.refreshCartDrawer = refreshCartDrawerContent;

  /* ============ MOBILE BOTTOM NAV — Active state ============ */
  const navLinks = document.querySelectorAll('[data-nav-link]');
  navLinks.forEach((link) => {
    if (link.getAttribute('href') === window.location.pathname) {
      link.classList.add('text-secondary-container');
      link.classList.remove('opacity-60');
    }
  });

})();